import mixpanel from "mixpanel-browser";
import config from "../config/config";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const MIXPANEL_TOKEN = config.mixpanelToken;

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn("Mixpanel token is missing! Check your .env file.");
    return;
  }

  if (import.meta.env.PROD) {
    mixpanel.init(MIXPANEL_TOKEN, { autocapture: true });
  }
}

// track arbitrary events
export function trackEvent(name: string, props = {}) {
  if (import.meta.env.PROD) {
    mixpanel.track(name, props);
  }
}

// specifically for page views
export function trackPageView(path: string) {
  if (import.meta.env.PROD) {
    mixpanel.track('Page View', { page: path });
  }
}

export function setUserAttributes(userId: string, attributes: {
  email: string;
  name: string;
  plan: string;
}) {
  if (import.meta.env.PROD) {
    mixpanel.identify(userId);
   
  mixpanel.people.set({
      '$name': attributes.name,
      '$email': attributes.email,
      'plan' : attributes.plan
    });
  }
}

// track page views
export function AnalyticsHandler() {
  const location = useLocation();

  useEffect(() => {
    // send a page view event whenever the route changes
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}